<template>
  <table-ag
    ref="agClimaDetallado"
    :row-data="datos"
    :columnDefs="columns"
    :filters="filters"
    :pagination="false"
    :menu-filter="{ group: 'group', active: true }"
    :merged-search="true"
    search-sub-field="name"
    theme-class="ag-theme-material clima-groups-grid"
    :actions="true"
    :components="components"
    :typeSelection="limitSelection > 1 ? 'multiple' : 'single'"
    :limitSelection="limitSelection"
    :onDeselectEmptyData="true"
    @selected="selected"
  ></table-ag>
</template>
<script>
import tableAg from "../dashboard/tableAg.vue";
import tooltipGraphBarHClima from "./components/tooltipGraphBarHClima.vue";
import cellComparison from "./components/cellComparison.vue";
import buttonsActionGroupClima from "./components/buttonsActionGroupClima.vue";
export default {
  data() {
    return {
      columns: [
        {
          field: "group",
          headerName: "Grupo",
          headerTooltip: "Grupo",
          hide: false,
          filter: "agTextColumnFilter",
          editable: false,
          resizable: true,
          checkboxSelection: true,
          showDisabledCheckboxes: true,
          // Token normalizado (sin acentos, en minúsculas, sin espacios) para
          // que coincida con el `groupToken` del buscador combinado de tableAg.
          getQuickFilterText: (params) => {
            return `FILTER_${this.normalizeText(params.value).replace(
              /\s+/g,
              "",
            )}_GRUPO`;
          },
          tooltipValueGetter: (params) => {
            return params.value;
          },
          suppressMenu: true,
          width: 160,
        },
        {
          field: "name",
          headerName: "Subgrupo",
          filter: "agTextColumnFilter",
          editable: false,
          resizable: true,
          // Normaliza el texto del subgrupo para que el buscador combinado sea
          // insensible a acentos.
          getQuickFilterText: (params) => this.normalizeText(params.value),
          tooltipValueGetter: (params) => {
            return params.value;
          },
          suppressMenu: true,
          width: 180,
        },
        {
          field: "CClimad",
          headerName: "N",
          valueGetter: (params) => {
            return params.data.n ? params.data.n : 0;
          },
          filter: "agTextColumnFilter",
          editable: false,
          suppressMenu: true,
          width: 90,
        },
        {
          field: "apoyod",
          valueGetter: (params) => {
            return this.getRange(params.data[params.colDef.field].p);
          },
          headerName: "Apoyo",
          headerTooltip: "Apoyo",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: "CellComparison",
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "apoyod",
          tooltipComponent: "TooltipGraphBarHClima",
          suppressMenu: true,
          width: 90,
        },
        {
          field: "calidadd",
          valueGetter: (params) => {
            return this.getRange(params.data[params.colDef.field].p);
          },
          headerName: "Calidad",
          headerTooltip: "Calidad",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: "CellComparison",
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "calidadd",
          tooltipComponent: "TooltipGraphBarHClima",
          suppressMenu: true,
          width: 90,
        },
        {
          field: "innovaciond",
          valueGetter: (params) => {
            return this.getRange(params.data[params.colDef.field].p);
          },
          headerName: "Innovación",
          headerTooltip: "Innovación",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: "CellComparison",
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "innovaciond",
          tooltipComponent: "TooltipGraphBarHClima",
          suppressMenu: true,
          width: 90,
        },
        {
          field: "metasd",
          valueGetter: (params) => {
            return this.getRange(params.data[params.colDef.field].p);
          },
          headerName: "Metas",
          headerTooltip: "Metas",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: "CellComparison",
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "metasd",
          tooltipComponent: "TooltipGraphBarHClima",
          suppressMenu: true,
          width: 90,
        },

        // Dimensiones Centrales

        {
          field: "lidd",
          valueGetter: (params) => {
            return this.getRange(params.data[params.colDef.field].p);
          },
          headerName: "Liderazgo",
          headerTooltip: "Liderazgo",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: "CellComparison",
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "lidd",
          tooltipComponent: "TooltipGraphBarHClima",
          suppressMenu: true,
          width: 90,
        },

        {
          field: "recd",
          valueGetter: (params) => {
            return this.getRange(params.data[params.colDef.field].p);
          },
          headerName: "Recursos",
          headerTooltip: "Recursos",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: "CellComparison",
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "recd",
          tooltipComponent: "TooltipGraphBarHClima",
          suppressMenu: true,
          width: 90,
        },

        {
          field: "compd",
          valueGetter: (params) => {
            return this.getRange(params.data[params.colDef.field].p);
          },
          headerName: "Compensación",
          headerTooltip: "Compensación",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: "CellComparison",
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "compd",
          tooltipComponent: "TooltipGraphBarHClima",
          suppressMenu: true,
          width: 90,
        },

        {
          field: "engad",
          valueGetter: (params) => {
            return this.getRange(params.data[params.colDef.field].p);
          },
          headerName: "Engagement",
          headerTooltip: "Engagement",
          filter: "agTextColumnFilter",
          editable: false,
          cellRenderer: "CellComparison",
          cellClass: (params) => this.cellClassRules(params),
          getQuickFilterText: (params) => {
            return "";
          },
          tooltipField: "engad",
          tooltipComponent: "TooltipGraphBarHClima",
          suppressMenu: true,
          width: 90,
        },

        {
          field: "CClimad",
          valueGetter: (params) => {
            return params.data[params.colDef.field].p;
          },
          headerName: "Total",
          filter: "agTextColumnFilter",
          cellRenderer: "CellComparison",
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          editable: false,
          resizable: true,
          suppressMenu: true,
          width: 80,
        },
        {
          field: "_id",
          headerName: "",
          colId: "_actions",
          editable: false,
          cellRenderer: "ButtonsActionGroupClima",
          cellRendererParams: {
            copyLink: this.copyLink,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            "padding-right": "5",
          },
          sortable: false,
          suppressMenu: true,
          width: 50,
        },
      ],
      components: {
        TooltipGraphBarHClima: () => {
          return {
            render: (h) =>
              h(tooltipGraphBarHClima, {
                props: {
                  nameQuadrants: this.nameQuadrants,
                  nameRanges: this.nameRanges,
                  getRange: this.getRange,
                },
                on: {},
              }),
          };
        },
        CellComparison: () => {
          return {
            render: (h) =>
              h(cellComparison, {
                props: {
                  nameRanges: this.nameRanges,
                  getRange: this.getRange,
                },
                on: {},
              }),
          };
        },
        ButtonsActionGroupClima: () => {
          return {
            render: (h) =>
              h(buttonsActionGroupClima, {
                props: {
                  copyLink: this.copyLink,
                },
                on: {},
              }),
          };
        },
      },
    };
  },
  props: {
    datos: {
      type: Array,
      required: true,
    },
    filters: {
      type: Array,
      default() {
        return [];
      },
    },
    limitSelection: Number,
    getRange: {
      type: Function,
      required: true,
    },
    nameQuadrants: {
      type: Object,
      required: true,
    },
    nameRanges: {
      type: Object,
      required: true,
    },
  },
  beforeMount() {
    // console.log(this.datos)
  },
  methods: {
    // Quita acentos/diacríticos y pasa a minúsculas para búsquedas insensibles
    // a acentos (debe coincidir con normalizeText de tableAg).
    normalizeText(value) {
      return String(value == null ? "" : value)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    cellClassRules(p, text = false) {
      const isEmpty = p.data.empty || false;
      p = p.value;

      if (!text && p && !isEmpty) {
        return `rangoT${p}`;
      }

      if (text && p >= 0 && !isEmpty) {
        const r = this.getRange(p);
        return `textT${r}`;
      }

      return text ? "textT0" : "rangoT0";
    },
    selected(i) {
      if (!Array.isArray(i)) i = [i];
      this.$emit("setFilterTable", i);
    },
    deselect() {
      this.$refs.agClimaDetallado.deselectAll();
      // Re-emitir para que el padre limpie la sección de filtros activos.
      this.$emit("setFilterTable", []);
    },
    deselectOne(filter) {
      // `filter` es un array de { group, name } (grupo + subgrupo a quitar).
      this.$refs.agClimaDetallado.deselectOne(filter);
      // Re-emitir la selección restante para refrescar los filtros activos.
      this.$emit(
        "setFilterTable",
        this.$refs.agClimaDetallado.getSelectedRows(),
      );
    },
    // Others
    copyLink(f) {
      this.$emit("copyLink", f);
    },
  },
  watch: {},
  components: {
    tableAg,
  },
};
</script>
<style lang="scss">
.ag-header-cell-label {
  justify-content: center !important;
}

/* Reduce el padding horizontal de los encabezados (solo en esta tabla) para
   que se vea más texto en columnas angostas. */
.clima-groups-grid .ag-header-cell {
  padding-left: 6px !important;
  padding-right: 6px !important;
}

/* Backgrounds */

/* White gridlines keep every heatmap tile visually separated,
   even when adjacent cells share the same range color. */
.rangoT1,
.rangoT2,
.rangoT3,
.rangoT4,
.rangoT5,
.rangoT6,
.rangoT0 {
  border: solid 2px #ffffff !important;
  color: rgba(65, 64, 64, 0.91);
}

.rangoT1 {
  background-color: var(--clima-1) !important;
}

.rangoT2 {
  background-color: var(--clima-2) !important;
}

.rangoT3 {
  background-color: var(--clima-3) !important;
}

.rangoT4 {
  background-color: var(--clima-4) !important;
}

.rangoT5 {
  background-color: var(--clima-5) !important;
}

.rangoT6 {
  background-color: var(--clima-6) !important;
}

.rangoT0 {
  background-color: #eceeec;
}

/* Text Colors */

.textT1 {
  color: #54a459 !important;
}

.textT2 {
  color: #abe59d !important;
}

.textT3 {
  color: var(--clima-3) !important;
}

.textT4 {
  color: var(--clima-4) !important;
}

.textT5 {
  color: var(--clima-5) !important;
}

.textT6 {
  color: var(--clima-6) !important;
}

.textT0 {
  color: rgba(165, 165, 165, 0.94);
}
</style>



// WEBPACK FOOTER //
// src/components/climan/TableGroups.vue